// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IContactSaveClaimsTeamsDto
 */
export interface IContactSaveClaimsTeamsDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof IContactSaveClaimsTeamsDto
     */
    claims_teams_ids?: Array<number>;
}

/**
 * Check if a given object implements the IContactSaveClaimsTeamsDto interface.
 */
export function instanceOfIContactSaveClaimsTeamsDto(value: object): value is IContactSaveClaimsTeamsDto {
    return true;
}

export function IContactSaveClaimsTeamsDtoFromJSON(json: any): IContactSaveClaimsTeamsDto {
    return IContactSaveClaimsTeamsDtoFromJSONTyped(json, false);
}

export function IContactSaveClaimsTeamsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContactSaveClaimsTeamsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claims_teams_ids': json['claims_teams_ids'] == null ? undefined : json['claims_teams_ids'],
    };
}

export function IContactSaveClaimsTeamsDtoToJSON(json: any): IContactSaveClaimsTeamsDto {
    return IContactSaveClaimsTeamsDtoToJSONTyped(json, false);
}

export function IContactSaveClaimsTeamsDtoToJSONTyped(value?: IContactSaveClaimsTeamsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claims_teams_ids': value['claims_teams_ids'],
    };
}

